/* eslint-disable css-modules/no-unused-class  */
import { useEffect, useState, FC } from 'react';
import { useSelector } from 'react-redux';
import { FullPageLoader } from 'learning-panel-components';
import { selectUserUuid } from '@redux/slices/userSlice';
import { useGetPrimaryCourseMetadata } from '@queries/platform/userContent';
import PrimaryCourse from './primaryCourse';

const PrimaryCourseContainer: FC<{ setIsPrimaryCourseDialogOpen: Function }> = ({
    setIsPrimaryCourseDialogOpen
}: {
    setIsPrimaryCourseDialogOpen: Function;
}) => {
    const userUuid = useSelector(selectUserUuid);
    const [primaryCourse, setPrimaryCourse] = useState<any>(null);

    const { data: primaryCourseData, isLoading } = useGetPrimaryCourseMetadata(userUuid);

    useEffect(() => {
        if (!primaryCourseData?.data) return;
        if (Object.keys(primaryCourseData.data).length === 0) {
            setIsPrimaryCourseDialogOpen(true);
            return;
        }
        const course = primaryCourseData.data;
        const primaryCourseTmp = {
            uuid: course.uuid,
            displayName: course.display_name,
            completionPercentage: course.completion_percentage,
            score: course.score,
            iconUrl: course.icon_url ?? `${process.env.PUBLIC_URL}/images/courseDefaultCard.svg`,
            totalLessons: course.total_lessons,
            completedLessons: course.completed_lessons
        };
        setPrimaryCourse(primaryCourseTmp);
    }, [primaryCourseData]);

    return isLoading || primaryCourse === null ? (
        <FullPageLoader />
    ) : (
        <PrimaryCourse
            isLoading={isLoading}
            score={primaryCourse?.score}
            completionPercentage={primaryCourse?.completionPercentage}
            totalLessons={primaryCourse?.totalLessons}
            competedLessons={primaryCourse?.completedLessons}
        ></PrimaryCourse>
    );
};

export default PrimaryCourseContainer;
